export default {
  xeroInvoices: [],
  xeroInvoice: undefined,
};
